export class FormComponent {

    type: string; // mandatory
    id?: string;
    label?: string = '';
    components?: FormComponent[] = [];
    options?: KeyValue[] | any; //Map<string,any> = new Map<string, any>();
    validators?: KeyValue[] | any; //Map<string,any> = new Map<string, any>();

}
export class KeyValue {
    key: string;
    value: any;
}
